import React from 'react';

import Room from '../room';

import S1 from './images/Standard.1.jpg';
import S2 from './images/Standard.10.jpg';
import S3 from './images/Standard.11.jpg';
import S4 from './images/Standard.13.jpg';
import S5 from './images/Standard.18.jpg';
import S6 from './images/Standard.23.jpg';
import S7 from './images/Standard.23.jpg';

const Standard = () => {

  const images = [
    { original: S1, thumbnail: S1},
    { original: S2, thumbnail: S2},
    { original: S3, thumbnail: S3},
    { original: S4, thumbnail: S4},
    { original: S5, thumbnail: S5},
    { original: S6, thumbnail: S7},
  ]

  return (
    <Room title="Standard" images={images} capacity={4}>

      <p className="p-services">Ubicadas alrededor de nuestro patio interno, las habitaciones Standard mantienen el concepto de las antiguas habitaciones de la casas coloniales con un toque de modernidad.</p>
      <p className="p-services">Equipada con TV por cable, WiFi, cofre de seguridad, calefacción central, aire acondicionado frío/calor, mini bar.</p>
    </Room>
  );
};

export default Standard;



// WEBPACK FOOTER //
// ./src/rooms/standard/index.js